// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__kSdid","sendOtp":"AuthorizeToLogin_sendOtp__1kpRT"};